import ApolloClient from 'apollo-client';
import { split } from 'apollo-link';
import { WebSocketLink } from 'apollo-link-ws';
import { getMainDefinition } from 'apollo-utilities';
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import { createUploadLink } from 'apollo-upload-client';
import { setContext } from 'apollo-link-context';
import { SubscriptionClient } from 'subscriptions-transport-ws';
import { getAppSecureGraphQL, logoutWithRedirectBack } from '~/common/utils';
import { currentToken, currentImpersonatorToken } from '~/common/auth';

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: {
    __schema: {
      types: [],
    },
  },
});

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
};

export const createClient = (baseURL = 'localhost:4000', sessionId = '') => {
  const httpLink = createUploadLink({
    uri: `${getAppSecureGraphQL('naluri')}${baseURL}/graphql`,
  });

  const wsLink = new WebSocketLink(
    new SubscriptionClient(`${getAppSecureGraphQL('websocket')}${baseURL}/subscriptions`, {
      lazy: true,
      reconnect: true,
      async connectionParams() {
        let token;

        await currentToken().then(jwtToken => {
          token = jwtToken;
        }).catch((err) => {
          if (err.code === "NotAuthorizedException") {
            // If refresh token, or current session is expired,
            // Logout and redirect users.
            logoutWithRedirectBack()
          }
        })

        const impersonatorToken = currentImpersonatorToken();

        return {
          headers: {
            Authorization: token ? `Bearer ${token}` : null,
            "x-naluri-impersonator-token": impersonatorToken ? impersonatorToken : null,
            Session: sessionId !== '' ? sessionId : null,
          },
        };
      },
    }),
  );

  const authLink = setContext(async (_, { headers }) => {
    let token;

    await currentToken().then(jwtToken => {
      token = jwtToken;
    }).catch((err) => {
      if (err.code === "NotAuthorizedException") {
        // If refresh token, or current session is expired,
        // Logout and redirect users.
        logoutWithRedirectBack()
      }
    })

    const impersonatorToken = currentImpersonatorToken();
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : null,
        "x-naluri-impersonator-token": impersonatorToken ? impersonatorToken : null,
        Session: sessionId !== '' ? sessionId : null,
      },
    };
  });

  const splitLink = split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
    },
    wsLink,
    authLink.concat(httpLink),
  );

  return new ApolloClient({
    link: splitLink,
    cache: new InMemoryCache({ fragmentMatcher }),
    defaultOptions: defaultOptions,
  });
};



// WEBPACK FOOTER //
// ./src/naluriApolloClient.js